<template>
  <div class="config-app">
    <h2 class="app-title">Apps Integrados</h2>
<!--    <p class="subtitle"></p>-->

    <div class="m-t-lg">
      Indisponível no momento.
    </div>
  </div>
</template>

<script>
import AppMixin from './appMixin'

export default {
  name: "ConfigApps",
  inject: ['config'],
  mixins: [AppMixin],
  data() {
    return {
      active: 'basico'
    }
  },
  computed: {
    menu() {
      return [
        {
          name: 'basico',
          label: 'Básico'
        }
      ]
    }
  }
}
</script>
